export const EXCEL_STYLES = [
    {
        id: 'totalLine',
        font: {
            size: 11,
            bold: true,
        },
    },
    {
        id: 'subHeader',
        font: {
            size: 13,
            bold: true,
        },
    },
    {
        id: 'detailHeader',
        font: {
            size: 11,
            bold: true,
        },
    },
    {
        id: 'detailRow',
        font: {
            size: 11,
        },
    },
];

export enum CONFIG_ACTION_BUTTONS {
    PUBLISH_VIEW = 'publishView',
    MAKE_DEFAULT = 'makeDefault',
    RESET_VIEW = 'resetView',
}

export enum REPORT_ACTIONS {
    MAKE_DEFAULT = 'make_default',
    RESET_DEFAULT = 'reset_default',
    SELECT_REPORT = 'select_report',
    REMOVE_REPORT = 'remove_report',
}
